module.exports = __webpack_public_path__ + "img/hotdog-top-map-old.a0389fa1.jpg";